import { EntregasFilters } from "./EntregasFilters";
import { EntregasTable } from "./EntregasTable";

/**
 * EntregasBody — Orquestra os dois blocos principais abaixo do cabeçalho
 * (Filtros + Tabela). Fica desacoplado do fluxo de diálogos/modais.
 *
 * Propaga o "contrato" de props por spread pra manter compatibilidade com os
 * componentes filhos sem duplicar a lista. Extraído de Entregas.jsx (fev/2026).
 */
export function EntregasBody({ filtersProps, tableProps }) {
  return (
    <>
      <EntregasFilters {...filtersProps} />
      <EntregasTable {...tableProps} />
    </>
  );
}
